var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanadaContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_31764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9423 20.7273H15.8271L15.4026 31.4173C14.7056 31.758 14.1086 32.2654 13.6674 32.8919C13.2262 33.5185 12.9552 34.2438 12.8798 35.0001H9.50195C12.9413 30.9911 14.862 25.952 14.9423 20.7273ZM21.6082 28.6036C20.6101 26.0895 20.0777 23.4227 20.0359 20.7273H19.1511L19.5756 31.4173C20.2726 31.758 20.8696 32.2654 21.3108 32.8919C21.752 33.5185 22.023 34.2438 22.0985 35.0001H25.4703C23.832 33.0885 22.5273 30.9275 21.6082 28.6036ZM18.6848 31.6853L18.2543 20.7273H16.7239L16.2934 31.6853V31.697L16.1619 35.0001H18.8163L18.6848 31.697V31.6853ZM20.7234 19.8535L21.1001 18.3971H13.8781L14.2548 19.8535H20.7234ZM15.582 17.5232H19.3962L18.8641 10.2412H16.1141L15.582 17.5232ZM19.4321 7.91097H15.5461V9.36737H19.4321V7.91097ZM18.2364 5.1438C18.2364 4.95067 18.1577 4.76545 18.0175 4.62888C17.8774 4.49232 17.6873 4.4156 17.4891 4.4156C17.2909 4.4156 17.1008 4.49232 16.9607 4.62888C16.8205 4.76545 16.7418 4.95067 16.7418 5.1438V7.03712H18.2364V5.1438ZM17.9375 3.3064V0.483308C17.9375 0.367429 17.8902 0.256297 17.8062 0.174358C17.7221 0.0924194 17.608 0.0463867 17.4891 0.0463867C17.3702 0.0463867 17.2561 0.0924194 17.1721 0.174358C17.088 0.256297 17.0407 0.367429 17.0407 0.483308V3.3064C17.3348 3.23189 17.6435 3.23189 17.9375 3.3064Z",
    fill: "#8A49D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_31764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaContact);
export default __webpack_public_path__ + "static/media/Canada-Contact.892958b4471423118121d4283862acf1.svg";
export { ForwardRef as ReactComponent };